import { useScrollReveal } from "../../../hooks/useScrollReveal";

export const BendWhoWeWorkWith = () => {
  const [headerRef, headerVis] = useScrollReveal();
  const [c1Ref, c1Vis] = useScrollReveal(0.1);
  const [c2Ref, c2Vis] = useScrollReveal(0.1);
  const [c3Ref, c3Vis] = useScrollReveal(0.1);
  const [noteRef, noteVis] = useScrollReveal();

  return (
    <section
      id="who-we-work-with"
      data-testid="bend-who-we-work-with-section"
      className="bg-[#F8FAFC] py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div ref={headerRef} className={`reveal ${headerVis ? 'visible' : ''}`}>
          <h2
            data-testid="bend-who-we-work-with-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(36px,5vw,68px)] tracking-[-0.03em] text-[#0F172A] leading-[1.0] max-w-[700px]"
          >
            We only take a few local accounts. Here's who's a fit.
          </h2>
        </div>

        {/* Cards */}
        <div className="mt-16 md:mt-24 grid md:grid-cols-3 gap-6 md:gap-8">
          {/* Service businesses */}
          <div
            ref={c1Ref}
            data-testid="bend-icp-service-card"
            className={`card-lift bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden reveal ${c1Vis ? 'visible' : ''}`}
          >
            <div className="h-1.5 bg-[#0064E0]" />
            <div className="p-8 md:p-10">
              <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0] mb-6 block">
                Local service
              </span>
              <h3 className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[26px] text-[#0F172A] leading-[1.1] tracking-[-0.01em]">
                Service businesses
              </h3>
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
                Trades, home services, med spas, clinics, law and accounting.
                More leads isn't the goal, qualified ones are. We tune the
                targeting and the funnel to bring in people who actually fit
                what you do and are ready to book, then tighten the handoff
                so fewer of them slip away.
              </p>
            </div>
          </div>

          {/* Restaurants */}
          <div
            ref={c2Ref}
            data-testid="bend-icp-restaurant-card"
            className={`card-lift bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden reveal ${c2Vis ? 'visible' : ''}`}
            style={{ transitionDelay: '100ms' }}
          >
            <div className="h-1.5 bg-[#0064E0]" />
            <div className="p-8 md:p-10">
              <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0] mb-6 block">
                Food & drink
              </span>
              <h3 className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[26px] text-[#0F172A] leading-[1.1] tracking-[-0.01em]">
                Restaurants and hospitality
              </h3>
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
                Restaurants, bars, cafes, breweries. We put money behind what
                actually fills seats and books tables, and make it dead simple
                for someone scrolling on their couch to end up with a reservation.
              </p>
            </div>
          </div>

          {/* Ecommerce */}
          <div
            ref={c3Ref}
            data-testid="bend-icp-ecommerce-card"
            className={`card-lift bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden reveal ${c3Vis ? 'visible' : ''}`}
            style={{ transitionDelay: '200ms' }}
          >
            <div className="h-1.5 bg-[#0064E0]" />
            <div className="p-8 md:p-10">
              <span className="text-[13px] font-semibold tracking-[0.15em] uppercase text-[#0064E0] mb-6 block">
                Ecommerce
              </span>
              <h3 className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[26px] text-[#0F172A] leading-[1.1] tracking-[-0.01em]">
                Selling past Bend
              </h3>
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
                Run a local brand that ships nationwide? Same deal. We get your
                ads profitable instead of just busy, and rebuild the pages so
                more visitors check out.
              </p>
            </div>
          </div>
        </div>

        {/* Qualification Note */}
        <div
          ref={noteRef}
          data-testid="bend-qualification-note"
          className={`mt-14 md:mt-20 reveal ${noteVis ? 'visible' : ''}`}
        >
          <div className="max-w-[800px] border-l-[3px] border-[#0064E0] pl-8">
            <p className="text-[16px] md:text-[17px] leading-[1.7] text-[#475569]">
              We keep the roster small on purpose. If you want a big agency
              with a ten-person team and a slide deck every Friday, that's
              honestly not us, and we'll say so on the call instead of wasting
              your time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
